import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_studentregistration,
  add_studentregistration,
  update_studentregistration,
  delete_studentregistration,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  studentregistration: [],
  studentregistrationlist: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    session: "",
    name: "",
    date_of_birth: "",
    pan_no: "",
    aadhar_no: "",
    age: "",
    gender: "",
    blood_group: "",
    mother_tongue: "",
    nationality: "",
    religion: "",
    caste: "",
    category: "",
    school_class: "",
    mobile_no: "",
    email: "",
    house_no: "",
    street: "",
    area: "",
    P_O: "",
    distt: "",
    city: "",
    state: "",
    pin: "",
    father_name: "",
    father_academic_qualification: "",
    father_occupation: "",
    father_designation: "",
    father_office_phone_no: "",
    father_work_detail: "",
    father_annual_income: "",
    father_phone: "",
    mother_name: "",
    mother_academic_qualification: "",
    mother_occupation: "",
    mother_designation: "",
    mother_office_phone_no: "",
    mother_work_detail: "",
    mother_annual_income: "",
    mother_phone: "",
    guardian_name: "",
    guardian_academic_qualification: "",
    guardian_occupation: "",
    guardian_designation: "",
    guardian_relation: "",
    guardian_phone: "",
    previous_school_name_address: "",
    previous_school_class: "",
    previous_school_session: "",
    previous_school_board: "",
    previous_school_medium: "",
    at_school: "",
    distance_from_home: "",
    reg_name:"",
    reg_amount:"",
    reg_fee:"",
     counsellor: "",
  },
};
// Async Thunks for API Calls
export const fetchstudentregistration = createAsyncThunk(
  "studentregistration/fetchstudentregistration",
  async (
    { page, page_size, school_id,search,filter_fields,token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_studentregistration(
        page,
        page_size,
        school_id,
        search,
        filter_fields,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createstudentregistration = createAsyncThunk(
  "studentregistration/createstudentregistration",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_studentregistration(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatestudentregistration = createAsyncThunk(
  "studentregistration/updatestudentregistration",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_studentregistration(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletestudentregistration = createAsyncThunk(
  "studentregistration/deletestudentregistration",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_studentregistration({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// hostel_category Slice
const studentregistrationSlice = createSlice({
  name: "studentregistrations",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(reduxState, action) {
      reduxState.formData = { ...action.payload };
    },
    resetFormData(reduxState) {
        reduxState.formData = {
          session: "",
          name: "",
          date_of_birth: "",
          pan_no: "",
          aadhar_no: "",
          age: "",
          gender: "",
          blood_group: "",
          mother_tongue: "",
          nationality: "",
          religion: "",
          caste: "",
          category: "",
          school_class: "",
          mobile_no: "",
          email: "",
          house_no: "",
          street: "",
          area: "",
          P_O: "",
          distt: "",
          city: "",
          state: "",
          pin: "",
          father_name: "",
          father_academic_qualification: "",
          father_occupation: "",
          father_designation: "",
          father_office_phone_no: "",
          father_work_detail: "",
          father_annual_income: "",
          father_phone: "",
          mother_name: "",
          mother_academic_qualification: "",
          mother_occupation: "",
          mother_designation: "",
          mother_office_phone_no: "",
          mother_work_detail: "",
          mother_annual_income: "",
          mother_phone: "",
          guardian_name: "",
          guardian_academic_qualification: "",
          guardian_occupation: "",
          guardian_designation: "",
          guardian_relation: "",
          guardian_phone: "",
          previous_school_name_address: "",
          previous_school_class: "",
          previous_school_session: "",
          previous_school_board: "",
          previous_school_medium: "",
          at_school: "",
          distance_from_home: "",
          reg_name:"",
          reg_amount:"",
          reg_fee:"",
           counsellor: "",
      };
    },
    setstudentregistration(state, action) {
      state.studentregistration = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
   
      // Fetch hostel_category
      .addCase(fetchstudentregistration.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchstudentregistration.fulfilled, (state, action) => {
        state.loading = false;
        state.studentregistration = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchstudentregistration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add hostel_category
      .addCase(createstudentregistration.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createstudentregistration.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createstudentregistration.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update hostel_category
      .addCase(updatestudentregistration.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatestudentregistration.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatestudentregistration.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete hostel_category
      .addCase(deletestudentregistration.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletestudentregistration.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletestudentregistration.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setstudentregistration,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
} = studentregistrationSlice.actions;
export default studentregistrationSlice.reducer;
